import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback Bearer token (used if cross-domain cookies are blocked, e.g. on custom domains).
// Stored on /auth/session success in AuthCallback and cleared on logout.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("session_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;
